const config = [
  {
    name: "United States (English)",
    url: "https://developer.box.com",
  },
  {
    name: "日本 (日本語)",
    url: "https://ja.developer.box.com",
  },
]

export default config
